export const endsWithGif = (link: string) => {
  return link.toLowerCase().endsWith(".gif");
};
